import React from "react";
import IconifyIcon from "../IconifyIcon";
import { useNavigate } from "react-router-dom";

interface MobileSecViewsHeaderProps {
  title: string;
  route: string;
}

const MobileSecViewsHeader = ({ title, route }: MobileSecViewsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="w-100 flex align-items-center justify-content-between"
      style={{ height: 40 }}
    >
      <div className="w-10" />
      <div
        className="w-80 flex justify-content-center align-items-center"
        style={{ height: 40 }}
      >
        <p className="body-text-md font-w-500">{title}</p>
      </div>
      <div
        className="w-10 flex justify-content-center align-items-center"
        style={{ height: 40 }}
      >
        <IconifyIcon
          icon={"material-symbols:close-rounded"}
          onClick={() => navigate(`${route}`)}
          className="subtitle-color"
          style={{ fontSize: 24, cursor: "pointer"}}
        />
      </div>
    </div>
  );
};

export default MobileSecViewsHeader;
